/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1TutoraiConfigMemoryMutationRequest,
  PutApiV1TutoraiConfigMemoryMutationResponse,
  PutApiV1TutoraiConfigMemory400,
  PutApiV1TutoraiConfigMemory401,
  PutApiV1TutoraiConfigMemory500,
} from "../../types/tutorAIConfigController/PutApiV1TutoraiConfigMemory.ts";

function getPutApiV1TutoraiConfigMemoryUrl() {
  const res = { method: "PUT", url: `/api/v1/tutorai/config/memory` as const };
  return res;
}

/**
 * @description Salva a memória no TutorAI. `isGlobal=true` → global. `classStudentId` sem `personId` → memória da turma. `classStudentId` + `personId` → memória específica do aluno (requer classStudentId). **(Requer Authorization para autenticação)**
 * @summary Atualizar memória do assistente (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/config/memory}
 */
export async function putApiV1TutoraiConfigMemory(
  data?: PutApiV1TutoraiConfigMemoryMutationRequest,
  config: Partial<RequestConfig<PutApiV1TutoraiConfigMemoryMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1TutoraiConfigMemoryMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigMemory400
      | PutApiV1TutoraiConfigMemory401
      | PutApiV1TutoraiConfigMemory500
    >,
    PutApiV1TutoraiConfigMemoryMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1TutoraiConfigMemoryUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
